<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-01-05 11:41:21
-->
<template>
  <com-dialog
    :visible.sync="visible"
    :title="type === 'created' ? '上传升级文件' : '详情'"
    width="450px"
  >
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :disabled="type === 'detail'">
      <el-form-item label="版本编号" prop="updateVersion">
        <el-input class="w-300px" v-model="ruleForm.updateVersion" />
      </el-form-item>
      <el-form-item label="版本名称" prop="name">
        <el-input class="w-300px" v-model="ruleForm.name" />
      </el-form-item>
      <el-form-item label="升级文件" v-if="type === 'detail'">
        <div>{{ ruleForm.fileName }}</div>
      </el-form-item>
      <el-form-item label="升级文件" prop="otaFile" v-else>
        <com-upload-file
          accept=".bin"
          :limit="1"
          :value.sync="ruleForm.otaFile"
          @success="handleUploadFile"
          @del-file="handleDelFile"
          param="BIN"
          tips=""
        ></com-upload-file>
      </el-form-item>
      <el-form-item>
        <div>
          <el-button type="primary" @click="handleSubmit('ruleForm')">确认</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </com-dialog>
</template>

<script>
import { addOtaApi } from '@/api/equ'
// eslint-disable-next-line import/no-extraneous-dependencies
import { deepCopy } from 'my-utility-function'

export default {
  data() {
    return {
      visible: false,
      type: 'created',
      ruleForm: {
        otaFile: [],
        name: '',
        updateVersion: ''
      },
      rules: {
        otaFile: [
          {
            required: true,
            message: '请上传升级文件',
            trigger: 'change'
          }
        ],
        updateVersion: [
          {
            required: true,
            message: '请输入版本编号',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入版本名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        setTimeout(() => {
          this.ruleForm = {
            otaFile: [],
            name: '',
            updateVersion: ''
          }
        }, 100)
      }
    }
  },
  methods: {
    open(type, row) {
      this.type = type
      if (row) {
        this.ruleForm = deepCopy(row)
      }
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleUploadFile(res) {
      this.$set(this.ruleForm, 'otaFile', res.data.code)
      this.$set(this.ruleForm, 'fileName', res.data.name)
    },
    handleDelFile() {
      this.ruleForm.otaFile = ''
    },
    handleSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            await addOtaApi(this.ruleForm)
            this.$emit('success')
            this.close()
          } catch (error) {
            console.log('error :>> ', error)
          }
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
